import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useDevice } from '@/hooks/useDevice/useDevice';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

// TODO: Add 'Turn on NFC' button and analytics
export const NFCNotEnabled = ({
  source = 'unknown',
  airKeyError,
}: {
  /** which check routed the user here, for diagnosing spikes in New Relic */
  source?: 'device_permission' | 'sdk_web_nfc_checker' | 'unknown';
  /** underlying SDK error code, only present when source is sdk_web_nfc_checker */
  airKeyError?: string;
}) => {
  const { content, locale } = useConfig();
  const { browserName, isMobile, hasNDEFReader, nfcEnabled } = useDevice();
  useAirKeyTracePageView('nfc_not_enabled', {
    source,
    airkey_error: airKeyError,
    browser_name: browserName,
    is_mobile: isMobile,
    has_ndef_reader: hasNDEFReader,
    nfc_enabled: nfcEnabled,
  });

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.nfcNotEnabled.img.src}`}
      iconSize={content.nfcNotEnabled.img.width}
      title={content.nfcNotEnabled.title[locale]}
      titleSize={20}
      body={content.nfcNotEnabled.description[locale]}
    />
  );
};
